import { render, staticRenderFns } from "./CompanyTaxCode.vue?vue&type=template&id=61552b2e&"
import script from "./CompanyTaxCode.vue?vue&type=script&lang=js&"
export * from "./CompanyTaxCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports